const apiOptions = {
    timeout:25000,
    networkTimeout: 25000,
        retry: 3,
      // exponential backoff delay
      retryDelay: (count: number) => Math.pow(2, count) * 1000,
}
export default apiOptions;